module.exports = __webpack_public_path__ + "img/economia_circular.8e9abcf5.jpg";